import React from "react";

/**
 * Function for rendering a calendar arrow SVG.
 *
 * @param {string} cls - optional class name for styling
 * @return {JSX.Element} the rendered SVG component
 */
export const CalendarArrow = ({ cls = "" }) => {
  return (
    <svg
      width="7"
      height="14"
      viewBox="0 0 7 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.82866 13.9995C5.53666 13.9995 5.24666 13.8725 5.04866 13.6265L0.22066 7.6265C-0.07734 7.2555 -0.07334 6.7255 0.23166 6.3595L5.23166 0.359495C5.58466 -0.0645046 6.21566 -0.121505 6.64066 0.231495C7.06466 0.584495 7.12166 1.2155 6.76766 1.6395L2.29266 7.0105L6.60766 12.3725C6.95366 12.8025 6.88566 13.4325 6.45466 13.7785C6.27066 13.9275 6.04866 13.9995 5.82866 13.9995Z"
        fill="currentColor"
      />
    </svg>
  );
};
